import React from "react";
import { Icon } from "@clarkinc/zest-design-system/ui";
import NoScriptLazyImage from "~/common/NoScriptLazyImage";
import { Product } from "~/common/Store/models/ProductListing";

import spritePath from "~/common/Icon/critical-symbol.svg";

const TopProductsRibbon = ({ ariaHidden }: { ariaHidden?: boolean }) => (
  <div
    className="vendor-ribbon absolute top-0 inset-x-2/4 transform -translate-x-1/2 -translate-y-1/2 flex items-center justify-center h-9 w-36 z-[1]"
    aria-hidden={ariaHidden}
  >
    <h2
      className="absolute mb-0 text-base-1/2 text-white [text-shadow:1px_1px_2px_#565555]"
      data-testid="vendor-top"
    >
      TOP PRODUCTS
    </h2>
    <Icon
      name="ribbon-small"
      spriteSheetHref={spritePath}
      className="fill-green-500 h-8"
    />
  </div>
);

interface Props {
  topProducts: Product[];
}

const BrandTopProducts = ({ topProducts }: Props) => {
  function renderImageAndDescription(product: Product) {
    return (
      <>
        <div className="product-image">
          <NoScriptLazyImage
            alt=""
            src={product.primaryImagePath}
            className="lazyLoad b-loaded"
          />
        </div>
        <div className="details">
          <div className="description" title={product.description}>
            {product.description}
          </div>
        </div>
      </>
    );
  }

  if (topProducts.length <= 0) {
    return null;
  }

  const displayTopProductsInline = topProducts.length <= 2;

  return (
    <div className="grid-children">
      {!displayTopProductsInline ? (
        <h2 className="sr-only">Top Products</h2>
      ) : (
        <TopProductsRibbon />
      )}
      {topProducts.map((product) => (
        <a
          href={product.link}
          className="grid-item grid-child vendor-child flex-col xxxl:flex-row -outline-offset-4"
          data-testid="vendor-child"
          key={product.description}
        >
          {displayTopProductsInline && (
            <div className="ag-item" data-testid="top-item">
              {renderImageAndDescription(product)}
            </div>
          )}
          {!displayTopProductsInline && renderImageAndDescription(product)}
        </a>
      ))}
      {!displayTopProductsInline && <TopProductsRibbon aria-hidden />}
    </div>
  );
};
export default BrandTopProducts;
